export const MAX_SIMULATION_COMPARISON = 4;
export const TASK_BATCH_SIZE = process.env.TASK_BATCH_SIZE ? +process.env.TASK_BATCH_SIZE : 10;
